const softwareVersion = "4.1." + (process.env.REACT_APP_VERSION ?? "0")

export default softwareVersion